import { FC, PropsWithChildren, RefObject, useEffect, useState } from 'react';

import { createPortal } from 'react-dom';

type CustomPortalProps = {
  containerRef: RefObject<HTMLDivElement>;
} & PropsWithChildren;

export const CustomPortal: FC<CustomPortalProps> = ({
  containerRef,
  children,
}) => {
  const [portalContainer, setPortalContainer] = useState(null);

  useEffect(() => {
    if (containerRef) {
      setPortalContainer(containerRef.current);
    }
  }, [containerRef]);

  return portalContainer !== null && createPortal(children, portalContainer);
};
